import { render, staticRenderFns } from "./ProjectsInput.vue?vue&type=template&id=3127fcf8"
import script from "./ProjectsInput.vue?vue&type=script&lang=js"
export * from "./ProjectsInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports